import { Employee } from 'data/users';
import jobBoardAPI from './base';

export interface JobAttachment {
  id: string;
  jobId: string;
  fileUrl: string;
  creator: Employee;
  format?: string;
  date?: string;
  preview?: string;
  mimeType?: string;
  size?: string;
  thumbnail?: string;
  fileName?: string;
  createdAt?: string;
}

const endpoint = {
  deleteFile: (fileId: string) => `/file/${fileId}`,
  uploadFileWithJob: (jobId: string, userId: string) =>
    `/file/upload/${jobId}/${userId}`
};

export const deleteFile = async (fileId: string) => {
  const response = await jobBoardAPI.delete(endpoint.deleteFile(fileId));
  return response.data;
};

export const uploadFileWithJob = async (
  file: File,
  jobId: string,
  userId: string
) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await jobBoardAPI.post(
    endpoint.uploadFileWithJob(jobId, userId),
    formData
  );
  return response.data;
};
